var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowNext = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 5,
  height: 8,
  fill: "none",
  viewBox: "0 0 5 8"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#75899D",
  d: "m1 7 3-3-3-3"
})));
export { SvgArrowNext as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNSIgaGVpZ2h0PSI4IiB2aWV3Qm94PSIwIDAgNSA4IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBkPSJNMSA3TDQgNEwxIDEiIHN0cm9rZT0iIzc1ODk5RCIvPgo8L3N2Zz4K";